<metric-mapping-dialog
  [dialogData]="data"
  [campaigns]="hubspotCampaignsList"
  [placeholderText]="placeholderText"
  (saveMappingState)="onSave($event)"
  (closeClick)="dialogRef.close()"
></metric-mapping-dialog>
